var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("card-info-component", {
    attrs: {
      title: _vm.$t("pages.permission.absences.unjustified"),
      value: _vm.value,
      isLoading: _vm.isLoading,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }